export enum Relation {
    REPRESENTATIVE = "REPRESENTATIVE",
    OWNER = "OWNER"
}

export function relationToString(relation: Relation): string {
    switch(relation){
        case Relation.OWNER:
            return "Owner";
        case Relation.REPRESENTATIVE:
            return "Representative";
        default: return '';
    }
}